import { createPortal } from "react-dom"

import { IconX } from "@tabler/icons-react"

import { cn } from "@/lib/utils"

import { Button } from "../Button"
import { Tooltip } from "../Tooltip"
import { LE_TableInstance } from "./types"

export function BulkActionsFloater<T extends Record<string, any> = object>({
  table,
  rowSelectedText,
}: {
  table: LE_TableInstance<T>
  rowSelectedText?: string
}) {
  const state = table.getState()
  if (!table.renderBulkActions) return null

  const totalSelected = table.getSelectedRowModel().flatRows.length
  const visible = totalSelected > 0

  return createPortal(
    <div
      className={cn(
        "fixed bottom-0 left-0 z-200 mx-auto flex w-full justify-center px-16 pb-4",
        "pointer-events-none invisible translate-y-full transition-transform",
        { "visible translate-y-0": visible },
      )}
    >
      <div className="pointer-events-auto flex items-center gap-16 rounded-md border-b border-solid border-border bg-popover-foreground px-6 py-4 text-body1 text-popover">
        <span>
          {rowSelectedText
            ? `${rowSelectedText} `
            : `${totalSelected} ${totalSelected > 1 ? "rows " : "row "}`}
          selected
        </span>
        <div className="flex items-center gap-2">
          <div className="flex flex-wrap gap-2">
            {visible &&
              table.renderBulkActions(state.rowSelection, {
                table,
                totalSelected,
              })}
          </div>
          <Tooltip content="Clear selection">
            <Button
              variant="neutral"
              icon={IconX}
              iconOnly
              onClick={() => table.toggleAllRowsSelected(false)}
            />
          </Tooltip>
        </div>
      </div>
    </div>,
    document.body,
  )
}
